var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CardSimple",
    { attrs: { title: "Short Circuit Outputs" } },
    [
      _c(
        "v-expansion-panels",
        { attrs: { multiple: "" } },
        _vm._l(_vm.outputObject, function (element) {
          return _c(
            "v-expansion-panel",
            { key: element.title },
            [
              _c("v-expansion-panel-header", [
                _vm._v(" " + _vm._s(element.title) + " "),
              ]),
              _c(
                "v-expansion-panel-content",
                [
                  _c("Table", {
                    attrs: { headers: element.headers, items: element.items },
                  }),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }